var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.isAuthenticated)?_c('sign-in'):_c('operator-shell',[_c('router-view')],1),_c('snackbar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }